<div class="text-center">
  Coming Soon ...
</div>
<!--<button class="btn btn-danger" [routerLink]="['/pomodoro']">Pomodoro</button>-->
<router-outlet></router-outlet>
